import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Styles/Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header-container">
      <div className="header">
        <div className="header-left">
          <Link to="/" className="logo" onClick={closeMenu}>
            DigiRay
          </Link>

          <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className={`nav-link ${isActive('/')}`} onClick={closeMenu}>
              Home
            </Link>
            <Link to="/ScanSelectionPage" className={`nav-link ${isActive('/ScanSelectionPage')}`} onClick={closeMenu}>
              Scan
            </Link>
            <Link to="/database" className={`nav-link ${isActive('/database')}`} onClick={closeMenu}>
              Database
            </Link>
            <Link to="/AboutUsPage" className={`nav-link ${isActive('/AboutUsPage')}`} onClick={closeMenu}>
              About Us
            </Link>
          </nav>
        </div>

        <div className="header-right">
          <Link to="/login" className="login-button" onClick={closeMenu}>
            Sign In
          </Link>

          <button
            className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;